module.exports = __webpack_public_path__ + "img/bco.1856d29f.svg";